/**
 * @fileoverview gRPC-Web generated client stub for reconpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reconpb/accountmapping.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.reconpb = require('./accountmapping_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.AccountMappingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.AccountMappingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListAccountMappingRequest,
 *   !proto.reconpb.ListAccountMappingResponse>}
 */
const methodDescriptor_AccountMappingService_ListAccountMapping = new grpc.web.MethodDescriptor(
  '/reconpb.AccountMappingService/ListAccountMapping',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListAccountMappingRequest,
  proto.reconpb.ListAccountMappingResponse,
  /**
   * @param {!proto.reconpb.ListAccountMappingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListAccountMappingResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListAccountMappingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListAccountMappingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListAccountMappingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.AccountMappingServiceClient.prototype.listAccountMapping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.AccountMappingService/ListAccountMapping',
      request,
      metadata || {},
      methodDescriptor_AccountMappingService_ListAccountMapping,
      callback);
};


/**
 * @param {!proto.reconpb.ListAccountMappingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListAccountMappingResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.AccountMappingServicePromiseClient.prototype.listAccountMapping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.AccountMappingService/ListAccountMapping',
      request,
      metadata || {},
      methodDescriptor_AccountMappingService_ListAccountMapping);
};


module.exports = proto.reconpb;

